import React, {useEffect} from 'react'
import { useLocation } from "react-router-dom";
import Footer from '../components/Footer';
import useIsMobile from "../hooks/useIsMobile";

const Vermouth = ({lang, translations}) => {
    const { pathname } = useLocation();
    const isDeviceMobile = useIsMobile();

    useEffect(() => {
        window.scrollTo(0, 0); 
      }, [pathname]); 
    
  return (
    <div className='flex-column background-cream'>
      {/* <div className='flex-column margin-top-10'>
      <div>
          <h2 className="blue-title">{translations[lang].winesmonth}</h2>  
        </div>
      <p  className='drinks-text'>{translations[lang].wines1}</p>
      <p className='drinks-text'>{translations[lang].wines11}</p>
      <br></br>
      <p className='drinks-text'>{translations[lang].wines2}</p>
      <p className='drinks-text'>{translations[lang].wines22}</p>
      <br></br>
      <p className='drinks-text'>{translations[lang].wines3}</p>
      <p className='drinks-text'>{translations[lang].wines33}</p>
      <br></br>
      <p className='drinks-text'>{translations[lang].wines4}</p>
      <p className='drinks-text'>{translations[lang].wines44}</p>
      </div> */}
      <div className='flex  margin-top-15'>
          <img className={isDeviceMobile ? "width100" : 'width70'} src={lang=== 'es' ?  "img/vermouthscarta.jpg" : lang==='en' ? "img/vermouthscarta.jpg" : lang==='ca' ? "img/vermouthscarta.jpg" : "img/vermouthscarta.jpg"} alt={translations[lang].cartavermutalt} />
      </div>
      <Footer lang={lang} translations={translations}/>
    </div>
  )
}

export default Vermouth